import { render, staticRenderFns } from "./ForeignExchange.vue?vue&type=template&id=021ae922"
import script from "./ForeignExchange.vue?vue&type=script&lang=js"
export * from "./ForeignExchange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports